import {Col} from '@modifi/ui'
import styled from 'styled-components'

import {backgroundColor} from '@modifi/colors'

export const NoteCol = styled(Col)`
  background-color: ${backgroundColor};
  border-radius: 6px;
  word-break: 'break-word';
  padding: 24px 24px;
`
